import _get from 'lodash/get';
import MediaConfigUtils from '../util/media-config-util';
import { applyProperties } from '../util/helpers';
import PluginConfig from './plugin-config';

/**
 *
 * @module MediaPlayerConfig
 * @desc The MediaPlayerConfig object contains the top-level configuration data and defaults necessary to create a player.
 * @class MediaPlayerConfig
 *
 */
class MediaPlayerConfig {

    /**
     *
     * @param {object} data Object used to create the MediaPlayerConfig object
     * @constructor
     *
     */
    constructor(config = {}) {

        /**
         *
         * @type {object}
         * @desc the config passed in on creation
         *
         */
        this.config = config;

        // Apply all the config properties to this object
        applyProperties(this, this.config);

        // Now, let's set some defaults

        /**
         *
         * @type {PlayerTypeConfig}
         * @desc the PlayerTypeConfig object created from data.playerTypeConfig in the data param
         *
         */
        this.playerTypeConfig = MediaConfigUtils.createPlayerTypeConfig(this.config);

        /**
         *
         * @type {Array}
         * @desc Array of PluginConfig objects
         *
         */
        this.pluginConfigs = this.getPluginConfigs(_get(this.config, 'pluginConfigs', []));

    }

    /**
     *
     * @desc Creates a list of PluginConfig objects for the defined plugins configs
     * @param {Array} pluginConfigs The list of plugin configs
     * @returns {Array}
     *
     */
    getPluginConfigs(pluginConfigs) {

        const plugins = [];

        pluginConfigs.forEach((pluginConfigJson) => {

            plugins.push(new PluginConfig(pluginConfigJson));

        });

        return plugins;

    }

}

export default MediaPlayerConfig;
